import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import('../views/Home.vue')
	},
	{
		path: '/angebote',
		name: 'angebote',
		component: () => import('../views/Angebote.vue')
	},
	{
		path: '/article/:articleID',
		name: 'article',
		component: () => import('../views/Article.vue')
	},
	{
		path: '/news',
		name: 'news',
		component: () => import('../views/News.vue')
	}
]
const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})
export default router
